var map = {
	"./encampment_vub.webp": 3817,
	"./kul4palestine.jpg": 6843,
	"./kulleuvenencampment.webp": 8518,
	"./logo_efg.jpg": 4968,
	"./logo_gs4p.jpg": 9704,
	"./logo_gse.jpg": 1815,
	"./logo_oulp.jpg": 6382,
	"./logo_s4pucl.jpg": 4347,
	"./logo_ua4p.jpg": 3495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7150;